import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  style: {"font-size":"20px"}
}
const _hoisted_3 = {
  key: 0,
  class: "spin"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { style: {"min-height":"100px"} }
const _hoisted_6 = { style: {"white-space":"pre-line"} }
const _hoisted_7 = { class: "link-buttons ion-text-right" }
const _hoisted_8 = { class: "ion-text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_infinite_scroll_content = _resolveComponent("ion-infinite-scroll-content")!
  const _component_ion_infinite_scroll = _resolveComponent("ion-infinite-scroll")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_footer = _resolveComponent("ion-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_buttons, { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  slot: "icon-only",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, { icon: _ctx.close }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_title, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, null, {
                  default: _withCtx(() => [
                    (_ctx.specificDiscipline)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
                          _cache[5] || (_cache[5] = _createTextVNode(" Programs related to ")),
                          _createElementVNode("b", null, _toDisplayString(_ctx.specificDiscipline.name), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("h2", _hoisted_2, " Select program(s) ")),
                    _cache[6] || (_cache[6] = _createElementVNode("p", null, [
                      _createElementVNode("small", null, "sorted in ascending order by their JUPAS codes")
                    ], -1))
                  ]),
                  _: 1,
                  __: [6]
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (!_ctx.readOnly)
          ? (_openBlock(), _createBlock(_component_ion_toolbar, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_searchbar, {
                  style: {"padding-bottom":"1px"},
                  mode: "ios",
                  modelValue: _ctx.programSearchKeyword,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.programSearchKeyword) = $event)),
                  placeholder: _ctx.t('search'),
                  onKeyup: _cache[2] || (_cache[2] = _withKeys((e) => e.target.blur(), ["enter"]))
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, {
      fullscreen: true,
      style: {"min-height":"150px"}
    }, {
      default: _withCtx(() => [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_ion_spinner)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currVisiblePrograms.slice(0, _ctx.numOfVisibleItems), (program) => {
                  return (_openBlock(), _createBlock(_component_ion_item, {
                    lines: "full",
                    key: program.id,
                    style: {"--min-height":"55px"}
                  }, {
                    default: _withCtx(() => [
                      (!_ctx.readOnly)
                        ? (_openBlock(), _createBlock(_component_ion_checkbox, {
                            key: 0,
                            style: {"margin-inline-start":"8px"},
                            slot: "start",
                            "onUpdate:modelValue": ($event: any) => (_ctx.onCheckProgram($event, program)),
                            modelValue: _ctx.chosenPrograms.find(p => p.id == program.id) != null
                          }, null, 8, ["onUpdate:modelValue", "modelValue"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createElementVNode("p", _hoisted_6, _toDisplayString(program.displayName), 1),
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_ion_button, {
                              fill: "outline",
                              href: _ctx.selectedGroup == 'eapp' ? program.cspeProgramUrl : program.jupasUrl,
                              target: "_blank"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.selectedGroup == 'eapp' ? 'E-APP' : 'JUPAS'), 1)
                              ]),
                              _: 2
                            }, 1032, ["href"]),
                            (program.programWebsite)
                              ? (_openBlock(), _createBlock(_component_ion_button, {
                                  key: 0,
                                  fill: "outline",
                                  href: program.programWebsite,
                                  target: "_blank"
                                }, {
                                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                                    _createTextVNode(" Website ")
                                  ])),
                                  _: 2,
                                  __: [7]
                                }, 1032, ["href"]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128)),
                _createVNode(_component_ion_infinite_scroll, {
                  onIonInfinite: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadData($event))),
                  threshold: "100px",
                  id: "infinite-scroll"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_infinite_scroll_content, {
                      "loading-spinner": "bubbles",
                      "loading-text": "Loading..."
                    })
                  ]),
                  _: 1
                })
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_8, _cache[8] || (_cache[8] = [
                _createElementVNode("p", null, "No programs available", -1)
              ]), 512), [
                [_vShow, _ctx.currVisiblePrograms.length == 0]
              ])
            ]))
      ]),
      _: 1
    }),
    (!_ctx.readOnly && _ctx.chosenPrograms.length > 0)
      ? (_openBlock(), _createBlock(_component_ion_footer, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_toolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  color: "success",
                  expand: "block",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.confirmSelect()))
                }, {
                  default: _withCtx(() => [
                    _cache[9] || (_cache[9] = _createTextVNode(" Done ")),
                    _createVNode(_component_ion_icon, {
                      slot: "end",
                      icon: _ctx.checkmark
                    }, null, 8, ["icon"])
                  ]),
                  _: 1,
                  __: [9]
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}